import css from '@emotion/css';
import styled from '@emotion/styled';

export const RowWrapper = styled.div<{
  header?: boolean;
  useScrollbarPadding?: boolean;
}>`
  display: grid;
  grid-template-columns: 150px 150px 200px 200px auto 60px;
  column-gap: 10px;
  ${({ header }) =>
    header
      ? css`
          height: 20px;
        `
      : css`
          height: 40px;
        `}

  ${({ useScrollbarPadding }) =>
    useScrollbarPadding
      ? css`
          padding-right: 10px;
        `
      : ''}
`;

export const RowCell = styled.div<{ right?: boolean }>`
  display: flex;
  align-items: center;
  padding: 0;
  width: 100%;

  ${({ right }) =>
    right
      ? css`
          justify-content: flex-end;
        `
      : ''}

  &:first-child {
    padding-left: 20px;
  }

  &:last-child {
    padding-right: 20px;
  }
`;
